import { render, staticRenderFns } from "./RegulatoryUpdateAcceptTerms.vue?vue&type=template&id=7ebec9f4"
import script from "./RegulatoryUpdateAcceptTerms.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegulatoryUpdateAcceptTerms.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports